import { render, staticRenderFns } from "./v80a1050.vue?vue&type=template&id=c321e3d0&scoped=true"
import script from "./v80a1050.vue?vue&type=script&lang=js"
export * from "./v80a1050.vue?vue&type=script&lang=js"
import style0 from "./v80a1050.vue?vue&type=style&index=0&id=c321e3d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c321e3d0",
  null
  
)

export default component.exports